import React, { useEffect, useState } from "react";

type ScrollingTypes = {
  limit?: number,
  element?: string,
};

export function Scrolling(props: ScrollingTypes) {
  const { limit = 100 } = props;
  const [state, setState] = useState<boolean>(false);

  const handlerScrolling = (): void => {
    const scrollValue = document.documentElement.scrollTop;

    if (scrollValue > limit) {
      setState(true);
    } else {
      setState(false);
    }
  };

  useEffect(() => {
    const win: Window = window;
    win.addEventListener("scroll", handlerScrolling);

    return () => win.removeEventListener("scroll", handlerScrolling);
  }, []);

  return state;
}
